'use strict';

/**
 *
 * @name: apiSearchService
 *
 */

function ApiSearchService(
  $http,
  $rootScope,
  $location,
  translateDate) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function search(page, fullQuery) {

    var query = (function() {
      if (typeof $location.search().search === 'undefined' || typeof $location.search().search === 'boolean') {
        return '';
      } else {
        return $location.search().search;
      }
    }());

    var target = $rootScope.apiUrlNew + '/search?' +
      'text=' + query +
      ($location.search().CategoryId ? '&CategoryId=' + $location.search().CategoryId : '') +
      (fullQuery.contributor.join() ? '&ContributorId=' + fullQuery.contributor.join() : '') +
      (fullQuery.curatorRole.join() ? '&curatorRole=' + fullQuery.curatorRole.join() : '') +
      (fullQuery.minDate ? '&minDate=' + fullQuery.minDate : '') +
      (fullQuery.maxDate ? '&maxDate=' + fullQuery.maxDate : '') +
      (fullQuery.minLength ? '&minLength=' + fullQuery.minLength : '') +
      (fullQuery.maxLength ? '&maxLength=' + fullQuery.maxLength : '') +
      (fullQuery.language.join() ? '&LanguageId=' + fullQuery.language.join() : '') +
      (fullQuery.order ? '&order=' + fullQuery.order : '') +
      '&limit=' + 24 +
      '&page=' + page;

    return $http
      .get(target).success(function(response) {

        angular.forEach(response.video.items, function(video) {

          video.publishDate = translateDate(video.publishDate);
          video.publishedAt = translateDate(video.publishedAt);
        });

        angular.forEach(response.slideshow.items, function(slideshow) {

          slideshow.publishDate = translateDate(slideshow.publishDate);
          slideshow.publishedAt = translateDate(slideshow.publishedAt);
        });

        angular.forEach(response.playlist.items, function(playlist) {

          playlist.createdAt = translateDate(playlist.createdAt);
          playlist.updatedAt = translateDate(playlist.updatedAt);
        });
      });
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    search: function(fullQuery) {
      return search(1, fullQuery);
    },
    searchMore: search
  };
}

export default ApiSearchService;



// WEBPACK FOOTER //
// ./app/components/_api/search.service.js